import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { SITE } from "@/config/site";
import { telLink } from "@/utils/whatsapp";

export const AppointmentCTA = () => (
  <section className="relative overflow-hidden bg-navy-900" data-testid="appointment-cta">
    <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-emerald-600/15" aria-hidden="true" />
    <div className="pointer-events-none absolute -bottom-24 -left-10 h-64 w-64 rounded-full bg-navy-700/50" aria-hidden="true" />
    <div className="relative mx-auto flex max-w-7xl flex-col items-center gap-8 px-4 py-16 text-center sm:px-6 lg:flex-row lg:justify-between lg:text-left lg:px-8">
      <div className="max-w-2xl">
        <h2 className="font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl">
          Book your consultation today
        </h2>
        <p className="mt-3 text-base leading-relaxed text-slate-300">
          Request an appointment on WhatsApp or call us directly. Appointment requests are subject to confirmation by the hospital.
        </p>
      </div>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Link
          to="/appointments"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-600 px-7 py-3.5 text-sm font-semibold text-white transition-all duration-200 hover:bg-emerald-500 hover:shadow-xl"
          data-testid="cta-book-appointment-button"
        >
          <CalendarCheck className="h-4 w-4" aria-hidden="true" /> Book an Appointment
        </Link>
        <a
          href={telLink}
          className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/30 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-white hover:bg-white/10"
          data-testid="cta-call-button"
        >
          <Phone className="h-4 w-4" aria-hidden="true" /> Call {SITE.phoneDisplay}
        </a>
      </div>
    </div>
  </section>
);
